import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'sonner';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState({});

  const handleAddToCart = (product, language) => {
    setCart((prev) => ({
      ...prev,
      [product.id]: (prev[product.id] || 0) + 1
    }));
    const productName = language === 'id' ? product.name : product.name_en;
    toast.success(`${productName} ditambahkan ke keranjang!`, {
      duration: 2000
    });
  };

  const handleIncreaseQuantity = (productId) => {
    setCart((prev) => ({
      ...prev,
      [productId]: (prev[productId] || 0) + 1
    }));
  };

  const handleDecreaseQuantity = (productId) => {
    setCart((prev) => {
      const newCart = { ...prev };
      if (newCart[productId] > 1) {
        newCart[productId] -= 1;
      } else {
        delete newCart[productId];
      }
      return newCart;
    });
  };

  const handleRemoveFromCart = (productId, productName) => {
    setCart((prev) => {
      const newCart = { ...prev };
      delete newCart[productId];
      return newCart;
    });
    if (productName) {
      toast.info(`${productName} dihapus dari keranjang`);
    }
  };

  const handleClearCart = () => {
    setCart({});
  };

  const getTotalItems = () => {
    return Object.values(cart).reduce((sum, qty) => sum + qty, 0);
  };

  return (
    <CartContext.Provider value={{ 
      cart, 
      handleAddToCart, 
      handleIncreaseQuantity, 
      handleDecreaseQuantity, 
      handleRemoveFromCart, 
      handleClearCart,
      getTotalItems 
    }}>
      {children}
    </CartContext.Provider>
  );
};
